import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import uniqueId from 'react-html-id';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/process.home.actions';
import * as actionsprocess from '../../../actions/api.process.actions';

import Grid from '@material-ui/core/Grid';
import Item from './Item';
import Loading from '../../dialogs/loading';
import Error from '../../dialogs/Error';

class Instances extends React.Component {
    constructor(props) {
        super(props);
        uniqueId.enableUniqueIds(this);
        const { process_paramters, param } = props;
        const { lastWeek, from, to, ended, local } = process_paramters;
        props.loadProcesses(lastWeek, from, to, ended, local, param);
    }

    state = {
        family: undefined,
    };

    updateTitle = (props) => {
        const { params, process } = props;
        if (
            process !== undefined &&
            params !== undefined &&
            params.process !== this.state.process
        ) {
            const familia = process.find((family) => family.id === params.family);
            if (familia !== undefined) {
                const proceso = familia.procesos.find((f) => f.codigo === params.process);
                if (proceso) {
                    this.props.setCurrentWindow(proceso.nombre);
                } else {
                    this.props.setCurrentWindow(params.process);
                }
            } else {
                this.props.setCurrentWindow(params.process);
            }
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.updateTitle(nextProps);
        this.setState({ process: nextProps.param });
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info, params, process, process_is_loading, process_has_error } = this.props;
        var data = undefined;
        if (process !== undefined && params !== undefined) {
            const familia = process.find((family) => family.id === params.family);
            if (familia !== undefined) {
                const proceso = familia.procesos.find((f) => f.codigo === params.process);
                if (proceso) {
                    data = proceso.instancias;
                }
            }
        }
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '57') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (process_has_error.hasErrored) {
            return <Error open message={process_has_error.error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9'}>
                    {process_is_loading && <Loading open opacity />}
                    <div className="flex_full">
                        <Grid container>
                            {data &&
                                data.length &&
                                data
                                    .sort((a, b) => (a.id > b.id ? 1 : -1))
                                    .map((info, i) => {
                                        return (
                                            <Item
                                                key={this.nextUniqueId()}
                                                data={info}
                                                last={data.length === i + 1}
                                            />
                                        );
                                    })}
                        </Grid>
                    </div>
                </div>
            );
        }
    }
}

Instances.propTypes = {
    info: PropTypes.object.isRequired,
    process: PropTypes.array.isRequired,
    process_is_loading: PropTypes.bool.isRequired,
    process_has_error: PropTypes.object.isRequired,
    process_paramters: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
        process: state.process,
        process_is_loading: state.process_is_loading,
        process_has_error: state.process_has_error,
        process_paramters: state.process_paramters,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsprocess), dispatch);
};

Instances = withRouter(Instances);
Instances = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Instances);

export default Instances;



// WEBPACK FOOTER //
// ./src/components/complex/instances/Instance.js